import { render, staticRenderFns } from "./TenantUserCreateScreen.vue?vue&type=template&id=5e8309a9&scoped=true&lang=pug"
import script from "./TenantUserCreateScreen.vue?vue&type=script&lang=ts"
export * from "./TenantUserCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./TenantUserCreateScreen.vue?vue&type=style&index=0&id=5e8309a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8309a9",
  null
  
)

export default component.exports